import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  amount: number | string
}

const MaxBalanceCap = ({ amount }: Props) => (
  <Box>
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Text.Normal color="grey000White">
        {i18n.t('time_off.available_tooltip.max_balance_cap')}
      </Text.Normal>
      <Text.Normal color="grey000White">{amount}</Text.Normal>
    </Box>
  </Box>
)

export default observer(MaxBalanceCap)
